import { inject, Injectable } from '@angular/core';
import { CmsApiService } from '../../core/services/api/cms-api.service';
import { CmsContentMapperService } from '../../core/services/cms-content-mapper.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpStatus } from '../../core/services/response-handler.service';
import { ContentUpdaterService } from '../../core/services/content-updater/content-updater.service';

export enum TemplateType {
  TEXT = 'text',
  ACCORDION = 'accordion',
  CONTACTS = 'contacts',
  BANKING = 'banking',
  BANKING_V2 = 'banking-wf',
  VIP = 'vip',
  REVIEWS = 'reviews',
  PAYMENT = 'payment'
}

@Injectable({
  providedIn: 'root'
})
export class StaticPageService {
  private _api = inject(CmsApiService);
  private _mapper = inject(CmsContentMapperService);
  private _contentUpdater = inject(ContentUpdaterService);


  /**
   * Get page item from CMS and prepare for using in frontend
   *
   * @param params
   */
  item(params: object = {}): Observable<any> {
    return this._contentUpdater.registerContent('page/item', params, () =>
      this._api.pageItem(params).pipe(
        map((page) => {
          if (page.statusCode === HttpStatus.OK) {
            return this._mapper.mapCmsData(page.data, {
              slug: 'slug',
              template_slug: 'template.slug',
              publishAt: 'publishAt.date',
              unpublishAt: 'unpublishAt.date',
              name: 'name',
            });
          }
          return { statusCode: page.statusCode };
        }),
      ),
    );
  }
}
